/* eslint-disable import/no-webpack-loader-syntax */
import PromiseWorker from 'promise-worker';

const worker = new Worker(new URL('./calculate-stats.worker.js', import.meta.url));
const promiseWorker = new PromiseWorker(worker);

export default {
    send: payload => promiseWorker.postMessage(payload),
};
